import {
  Module
} from "wrapper6";

var $ = jQuery;

export default class ContactTracking extends Module {

  ready(app) {

    document.addEventListener('wpcf7mailsent', function (event) {

      if (event.detail.contactFormId == 8 || event.detail.contactFormId == 2761) {
        ga('send', 'event', 'Kontaktformular', 'submit', 'Kontaktformular');
        dataLayer.push({
          'event': 'Kontaktformular',
          'formName': 'Kontaktformular'
        });
      }
    }, false);
  }
}